module.exports = __webpack_public_path__ + "img/257.name_tag.33197474.svg";